import ChooseReportPage from "./components/ChooseReportPage";
import { useLastOpenedReport } from "./hooks/useLastOpenedReport";
import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

// Report Builder's index route: reopens the user's most recently opened report
// or, when there is none (or it no longer exists), shows the list of reports.
// It never runs a report on its own.
const ReportsIndex = ({ reports = [], onCreate }) => {
  const navigate = useNavigate();
  const { getLastOpened } = useLastOpenedReport();
  const lastOpened = getLastOpened();
  if (lastOpened && reports.some((r) => r.internalName === lastOpened)) {
    return <Navigate to={lastOpened} replace />;
  }
  return (
    <ChooseReportPage
      reports={reports}
      onSelect={(reportId) => navigate(reportId)}
      onCreate={onCreate}
    />
  );
};

export default ReportsIndex;
